import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { AgentType } from '@domain-group/fe-allhomes-library';
import * as styles from './allhomes-listing-card-agency-details-old.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesListingCardAgencyDetailsOld = _ref => {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? AgentType.Agent.name : _ref$type,
    appearance = _ref.appearance,
    name = _ref.name,
    logo = _ref.logo,
    url = _ref.url,
    _ref$agents = _ref.agents,
    agents = _ref$agents === void 0 ? [] : _ref$agents,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick;
  var isPrivateLister = () => type === AgentType.PrivateLister.name;
  var isVerticalCard = appearance === 'vertical';
  var agencyLogoInner = () => ___EmotionJSX("span", null, appearance === 'horizontal' && name && ___EmotionJSX("span", {
    id: "agencyName",
    css: styles.agencyLogoName
  }, name), ___EmotionJSX("span", null, ___EmotionJSX("img", {
    src: logo !== null && logo !== void 0 ? logo : undefined,
    css: styles.agencyLogo,
    alt: name !== null && name !== void 0 ? name : undefined
  })));
  var agencyWithLogo = () => {
    if (!isEmpty(url)) {
      return ___EmotionJSX("a", {
        css: styles.agencyLink,
        href: url !== null && url !== void 0 ? url : undefined,
        onClick: evt => {
          _onClick(evt);
          evt.stopPropagation();
        }
      }, agencyLogoInner());
    }
    return agencyLogoInner();
  };
  var agencyTextOnly = () => {
    if (!isEmpty(url)) {
      return ___EmotionJSX("a", {
        css: styles.agencyName,
        href: url !== null && url !== void 0 ? url : undefined,
        onClick: evt => {
          _onClick(evt);
          evt.stopPropagation();
        }
      }, name);
    }
    return ___EmotionJSX("span", {
      css: styles.agencyName
    }, name);
  };
  var agencyOrLogo = () => {
    if (!isEmpty(logo)) {
      return agencyWithLogo();
    }
    return agencyTextOnly();
  };
  var renderNames = () => {
    var names = [];
    if (isPrivateLister() && !isEmpty(name)) {
      names.push(name);
    } else {
      if (!agents || agents.length === 0) {
        return ___EmotionJSX(React.Fragment, null);
      }
      agents.forEach(agent => {
        if (!isEmpty(agent.name)) {
          names.push(agent.name);
        }
      });
    }
    return ___EmotionJSX("div", {
      css: styles.name(isVerticalCard),
      "data-test-id": "agency-details-name"
    }, names.join(' & '));
  };
  return ___EmotionJSX("div", {
    css: styles.agencyDetails(isVerticalCard)
  }, ___EmotionJSX("div", {
    css: styles.inner(isVerticalCard)
  }, renderNames(), ___EmotionJSX("div", {
    css: styles.type(isVerticalCard),
    "data-test-id": "agency-details-type"
  }, isPrivateLister() ? ___EmotionJSX("div", {
    css: styles.agencyLogoName
  }, "Private lister") : agencyOrLogo())));
};
export { AllhomesListingCardAgencyDetailsOld };